export default __webpack_public_path__ + "static/media/2.d554a01b.jpg";